import * as React from "react";
import { useParams, useNavigate } from "react-router-dom";
//import firebase from 'firebase/compat';
import Grid from "@mui/material/Grid";
import { Paper } from "@mui/material";
import Typography from "@mui/material/Typography";
import { CircularProgress } from "@mui/material";
import { db } from "../../Environment/firebase";
import { Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import { NotFound } from "../../Pages/Error/NotFound";
import ManagementForms from "./ManagementForms";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import ImageManagementForms from "./ImageManagementForms";
import KeyImageManagementForms from "./KeyImageManagementForms";
import { Divider } from "@mui/material";
import { CatalogueUniversalViewerService } from "../Viewer/CatalogueUniversalViewerService";
import { CatalogueViewerService } from "../Viewer/CatalogueViewerService";

export default function CatalogueManagement(): JSX.Element {
  const { CatalogueId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [title, setTitle] = React.useState("");
  const [PatientSex, setPatientSex] = React.useState("");
  const [PatientAge, setPatientAge] = React.useState("");
  const [share, setShare] = React.useState("false");
  const [site, setSite] = React.useState("");
  const [modality, setModality] = React.useState<string>("");
  const [siteTags, setSiteTags] = React.useState<string[]>([]);
  const [organTags, setOrganTags] = React.useState<string[]>([]);
  const [patientId, setPatientId] = React.useState("");
  const [serieses, setSerieses] = React.useState([]);
  const [dicomDatalist, setDicomDatalist] = React.useState<
    { series: string; seriesNumber: number; protocol: string; share: boolean }[]
  >([]);
  const [keyImageDataList, setKeyImageDataList] = React.useState<
    { path: string; name: number; description: string; share: boolean }[]
  >([]);
  const [offline, setOffline] = React.useState(false);
  const [clinicalDiagnosis, setClinicalDiagnosis] = React.useState("");
  const [originalClinicalDiagnosis, setOriginalClinicalDiagnosis] =
    React.useState("");
  const [findings, setFindings] = React.useState("");
  const [originalFindings, setOriginalFindings] = React.useState("");
  const [positiveFindings, setPositiveFindings] = React.useState("");
  const [diagnosis, setDiagnosis] = React.useState("");
  const [originalDiagnosis, setOriginalDiagnosis] = React.useState("");
  const [update, setUpdate] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [exist, setExist] = React.useState(false);
  const tablePageState = location.state as {
    page: number;
    rowsPerPage: number;
  };

  const getDataset = async (serieses: string[], id: string) => {
    const ImageDatas = await Promise.all(
      serieses.map(async (series) => {
        const dataset = await db
          .collection("dwh")
          .doc(id)
          .collection("dicomData")
          .doc(series)
          .get()
          .then((doc) => {
            return {
              series: series,
              seriesNumber: doc.data()?.seriesNumber,
              protocol: doc.data()?.protocol || "",
              share: doc.data()?.share,
            };
          });
        return dataset;
      })
    );
    return ImageDatas;
  };

  const getKeyImageDataset = async (
    keyImages: string[],
    id: string
  ): Promise<
    {
      path: string;
      name: number;
      description: string;
      share: boolean;
    }[]
  > => {
    const ImageDatas = await Promise.all(
      keyImages.map(async (keyImage) => {
        const dataset = await db
          .collection("dwh")
          .doc(id)
          .collection("KeyImageData")
          .doc(keyImage)
          .get()
          .then((doc) => {
            return {
              path: keyImage,
              name: doc.data()?.name,
              description: doc.data()?.description || "",
              share: doc.data()?.share,
            };
          });
        return dataset;
      })
    );
    return ImageDatas;
  };

  const fetchData = async (
    serieses: string[],
    keyImages: string[],
    id: string
  ) => {
    const [imageDatas, keyImageDatas] = await Promise.all([
      getDataset(serieses, id),
      getKeyImageDataset(keyImages, id),
    ]);

    setDicomDatalist(imageDatas);
    setKeyImageDataList(keyImageDatas);
  };

  // どこかで上記の関数を呼び出す

  React.useEffect(() => {
    db.collection("dwh")
      .doc(CatalogueId)
      .get()
      .then(async (doc) => {
        if (doc.exists) {
          const docx = doc.data();
          setPatientSex(docx?.sex || "unknown");
          setPatientAge(docx?.age);
          setSite(docx?.site);
          setSiteTags(docx?.siteTags || []);
          setOrganTags(docx?.organTags || []);
          setShare(docx?.share);
          setDiagnosis(docx?.diagnosisAnonymize || "");
          setClinicalDiagnosis(docx?.clinicalDiagnosisAnonymize || "");
          setFindings(docx?.findingsAnonymize || "");
          setOriginalFindings(docx?.findings);
          setOriginalClinicalDiagnosis(docx?.clinicalDiagnosis);
          setOriginalDiagnosis(docx?.diagnosis);
          setPositiveFindings(docx?.positiveFindings);
          setTitle(docx?.title);
          setPatientId(docx?.patientId);
          setModality(docx?.modality);
          setSerieses(docx?.Serieses);
          await fetchData(
            docx?.Serieses,
            docx?.KeyImages || [],
            CatalogueId || ""
          );
          setShow(true);
          setExist(true);
        } else {
          setShow(true);
        }
      })
      .catch((err) => {
        if (String(err).includes("client is offline")) {
          setOffline(true);
        }
      });
  }, [CatalogueId]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getContentsData = (
    value: string | boolean | string[],
    name: string
  ) => {
    if (name === "title" && typeof value === "string") {
      setTitle(value);
    } else if (name === "PatientAge" && typeof value === "string") {
      setPatientAge(value);
    } else if (name === "PatientSex" && typeof value === "string") {
      setPatientSex(value);
    } else if (name === "share" && typeof value === "string") {
      setShare(value);
    } else if (name === "modality" && typeof value === "string") {
      setModality(value);
    } else if (name === "site" && typeof value === "string") {
      setSite(value);
    } else if (name === "findings" && typeof value === "string") {
      setFindings(value);
    } else if (name === "positiveFindings" && typeof value === "string") {
      setPositiveFindings(value);
    } else if (name === "diagnosis" && typeof value === "string") {
      setDiagnosis(value);
    } else if (name === "clinicalDiagnosis" && typeof value === "string") {
      setClinicalDiagnosis(value);
    }
  };

  const getDicomDatalist = (
    value: {
      series: string;
      seriesNumber: number;
      protocol: string;
      share: boolean;
    }[]
  ) => {
    setDicomDatalist(value);
  };

  const getKeyImageDatalist = (
    value: {
      path: string;
      name: number;
      description: string;
      share: boolean;
    }[]
  ) => {
    setKeyImageDataList(value);
  };

  const getTaglist = (value: string[], name: string) => {
    if (name === "site") {
      setSiteTags(value);
    } else if (name === "organ") {
      setOrganTags(value);
    }
  };
  const changeData = () => {
    setUpdate(true);

    const data = {
      title: title || "",
      share: share || "false",
      siteTags: siteTags,
      organTags: organTags,
      clinicalDiagnosisAnonymize: clinicalDiagnosis || "",
      findingsAnonymize: findings || "",
      diagnosisAnonymize: diagnosis || "",
      positiveFindings: positiveFindings || "",
    };

    type uploadDataType = {
      title: string;
      share: string;
      siteTags: string[];
      organTags: string[];
      clinicalDiagnosisAnonymize: string;
      findingsAnonymize: string;
      diagnosisAnonymize: string;
      positiveFindings: string;
    };

    async function assignCaseNumberIfNeeded(docRef: any) {
      const currentDoc = await docRef.get();
      if (!currentDoc.exists || currentDoc.data().casenumber !== undefined)
        return null;

      const snapshot = await db
        .collection("dwh")
        .where("casenumber", "!=", null)
        .get();
      const maxCaseNumber = Math.max(
        ...snapshot.docs.map((doc) => Number(doc.data().casenumber) || 0)
      );
      const newCaseNumber = maxCaseNumber + 1;
      await docRef.set({ casenumber: newCaseNumber }, { merge: true });
      return newCaseNumber;
    }

    async function upload(id: string, data: uploadDataType) {
      const docRef = db.collection("dwh").doc(id);

      // casenumber を必要に応じて自動付与
      await assignCaseNumberIfNeeded(docRef);

      const result = await setDoc(
        docRef,
        {
          ...data,
          publishDate: serverTimestamp(), // ← ここを追加！
        },
        { merge: true }
      );

      // dicomData のアップロード
      dicomDatalist.map(async (dicomData) => {
        await db
          .collection("dwh")
          .doc(id)
          .collection("dicomData")
          .doc(dicomData.series)
          .set(
            {
              protocol: dicomData.protocol || "",
              share: dicomData.share || false,
            },
            { merge: true }
          );
      });

      // KeyImageData のアップロード
      keyImageDataList.map(async (keyImageData) => {
        await db
          .collection("dwh")
          .doc(id)
          .collection("KeyImageData")
          .doc(keyImageData.path)
          .set(
            {
              path: keyImageData.path,
              name: keyImageData.name,
              description: keyImageData.description || "",
              share: keyImageData.share || false,
            },
            { merge: true }
          );
      });

      return result;
    }

    upload(CatalogueId || "", data)
      .then(() => {
        console.log("Document successfully written!");
        setUpdate(false);
        navigate("/mypage/catalogue", { state: tablePageState });
      })
      .catch((err) => {
        console.log("error:", err);
        setUpdate(false);
      });
  };

  // const changeData = () => {
  //   setUpdate(true)
  //   const data = {
  //     title:title || "",
  //     share:share || 'false',
  //     siteTags:siteTags,
  //     organTags:organTags,
  //     clinicalDiagnosisAnonymize:clinicalDiagnosis || "",
  //     findingsAnonymize:findings || "",
  //     diagnosisAnonymize:diagnosis || "",
  //     positiveFindings:positiveFindings || "",
  //   };
  //   type uploadDataType = {
  //     title:string,
  //     share:string,
  //     siteTags:string[],
  //     organTags:string[],
  //     clinicalDiagnosisAnonymize:string,
  //     findingsAnonymize:string,
  //     diagnosisAnonymize:string,
  //   }
  //   async function upload(id:string,data:uploadDataType){
  //     const result = await setDoc(doc(db, "dwh", id), data,{ merge: true });
  //     dicomDatalist.map(async(dicomData)=>{
  //       await db.collection('dwh')
  //           .doc(id)
  //           .collection('dicomData')
  //           .doc(dicomData.series)
  //           .set({
  //             protocol:dicomData.protocol || '',
  //             share:dicomData.share || false,
  //           },{ merge: true });
  //   })
  //     keyImageDataList.map(async(keyImageData)=>{
  //       await db.collection('dwh')
  //           .doc(id)
  //           .collection('KeyImageData')
  //           .doc(keyImageData.path)
  //           .set({
  //             path: keyImageData.path,
  //             name: keyImageData.name,
  //             description: keyImageData.description || '',
  //             share: keyImageData.share || false,
  //           },{ merge: true });
  //   })
  //     return result
  //   }

  //   upload(CatalogueId || '',data)
  //   .then(() => {
  //     console.log("Document successfully written!");
  //     setUpdate(false);
  //     navigate('/mypage/catalogue',{state:tablePageState})
  //   })
  //   .catch((err) => {
  //     console.log("error:", err);
  //     setUpdate(false);
  //   });
  //   }

  return (
    <div>
      {
        <div>
          {offline ? (
            <Grid>offlineです。</Grid>
          ) : (
            <div>
              {show ? (
                <div>
                  {exist ? (
                    <Grid>
                      <Paper sx={{ m: 5, p: 5 }}>
                        <ManagementForms
                          getContentsData={(value, name) =>
                            getContentsData(value, name)
                          }
                          getTaglist={(value, name) => getTaglist(value, name)}
                          title={title}
                          CatalogueId={CatalogueId || ""}
                          PatientId={patientId}
                          PatientAge={PatientAge}
                          PatientSex={PatientSex}
                          share={share}
                          site={site}
                          siteTags={siteTags}
                          organTags={organTags}
                          modality={modality}
                          clinicalDiagnosis={clinicalDiagnosis}
                          diagnosis={diagnosis}
                          findings={findings}
                          positiveFindings={positiveFindings}
                          originalFindings={originalFindings}
                          originalClinicalDiagnosis={originalClinicalDiagnosis}
                          originalDiagnosis={originalDiagnosis}
                        ></ManagementForms>
                        <Grid>
                          <Typography component="h2" variant="h6" gutterBottom>
                            画像
                          </Typography>
                          <CatalogueUniversalViewerService
                            CatalogueId={CatalogueId || ""}
                            displayAllImage={true}
                            title={title}
                            age={PatientAge}
                            sex={PatientSex}
                            modality={modality}
                          ></CatalogueUniversalViewerService>
                        </Grid>
                        <ImageManagementForms
                          getContentsData={(value, name) =>
                            getContentsData(value, name)
                          }
                          getDicomDatalist={(value) => getDicomDatalist(value)}
                          dicomDatalist={dicomDatalist}
                        ></ImageManagementForms>
                        <Divider sx={{ mt: 2, mb: 2 }}></Divider>
                        <KeyImageManagementForms
                          CatalogueId={CatalogueId || ""}
                          // getContentsData={(value, name) => getContentsData(value, name)}
                          getKeyImageDatalist={(value) =>
                            getKeyImageDatalist(value)
                          }
                          KeyImageDatalist={keyImageDataList}
                        ></KeyImageManagementForms>
                      </Paper>
                      <div>
                        {update ? (
                          <Grid
                            display="flex"
                            sx={{ m: 3 }}
                            gap={2}
                            justifyContent="center"
                            alignItems="center"
                          >
                            <CircularProgress />
                            <Typography
                              component="h2"
                              variant="h6"
                              gutterBottom
                            >
                              Now Uploading
                            </Typography>
                          </Grid>
                        ) : (
                          <Grid
                            display="flex"
                            sx={{ m: 3 }}
                            gap={2}
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Button variant="contained" onClick={changeData}>
                              更新する
                            </Button>
                            <Button
                              variant="outlined"
                              onClick={() =>
                                navigate("/mypage/catalogue", {
                                  state: tablePageState,
                                })
                              }
                            >
                              戻る
                            </Button>
                          </Grid>
                        )}
                      </div>
                    </Grid>
                  ) : (
                    <NotFound></NotFound>
                  )}
                </div>
              ) : (
                <div>
                  <CircularProgress />
                  <Typography component="h2" variant="h6" gutterBottom>
                    Now Loading
                  </Typography>
                </div>
              )}
            </div>
          )}
        </div>
      }
    </div>
  );
}
